<template>
  <div class="zutu">
    <div class="width1000">
      <div class="title">

        <p>{{dataList.mainTitle}}</p>

      </div>
      <div class="picList">
        <swiper :options="swiperOption"
                ref="mySwiper">
          <swiper-slide v-for="(item,index) in dataList.data"
                        :key="index">
            <div class="pic-item">
              <div class="container">
                <a :href="item.url"
                   target="_blank "
                   class="linkImg"><img :src="item.imgUrl"></a>
                <p>
                  <a v-if="item.dataType=='article'"
                     :href="'/h5/detail.html?artId='+item.dataVal"
                     target="_blank ">{{item.title}}</a>
                  <a v-else
                     :href="item.dataVal"
                     target="_blank ">{{item.title}}</a>
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev"
               slot="button-prev"></div>
          <div class="swiper-button-next"
               slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      swiperOption: {
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        slidesPerView: 5,
        spaceBetween: 0,
      }

    }

  },
  props: ['dataList'],
  mounted () {

  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {

  },
  watch: {
    dataList (val) {

      this.dataList = val;
    }
  }
}
</script>
<style lang="less">
.zutu {
  margin-top: 30px;
  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    // padding: 0 20px;
  }
  .swiper-container {
    // padding: 0 20px;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url('../../assets/images/picArrow_r.png');
    background-size: 30px 30px;
    top: 100px;
    right: 20px;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url('../../assets/images/picArrow_l.png');
    left: 0;
    background-size: 30px 30px;
    top: 100px;
  }
  .el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.6);
  }
  .el-carousel__arrow--right {
    right: 4px;
  }
  .el-carousel__arrow--left {
    left: 4px;
  }
  // margin-top: -10px;
  .title {
    height: 34px;
    border-bottom: 1px solid #c9dff4;
    p {
      display: inline-block;
      height: 30px;
      font-size: 20px;
      color: #1479d7;
      border-bottom: 4px solid #0276da;
    }
  }
  .picList {
    .pic-item {
      padding-top: 20px;
      width: 100%;
      // float: left;
      .container {
        width: 90%;
        // margin: 0 auto;
        .linkImg {
          width: 100%;
          img {
            width: 100%;
            height: 106px;
            border-radius: 6px;
          }
        }

        p {
          margin: 10px 0 0;
          font-size: 14px;
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          height: 48px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p:hover a {
          color: #e60012;
        }
      }
    }
  }
}
</style>
